import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { getStackVendorSettingsUrl } from "shared/Stack/OpenTofuMigration/helpers";
import { OpenTofuMigrationQueueEntryNode } from "shared/Stack/OpenTofuMigration/gql";

const OpenTofuMigrationQueueTableStackCell = ({
  item: entry,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrationQueueEntryNode>) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellLink href={getStackVendorSettingsUrl(entry.stack.id)}>
      {entry.stack.name}
    </TableCellLink>
  </TableSimpleCell>
);

export default OpenTofuMigrationQueueTableStackCell;
